import $ from "jquery";

$(".accordion_head").on("click", function() {
    if (
        !$(this)
            .next(".accordion_body")
            .is(":visible")
    ) {
        $(this)
            .next(".accordion_body")
            .toggle();
        $(this)
            .children(".plusminus")
            .addClass("rotate-90")
            .removeClass("-rotate-90");
    } else {
        $(this)
            .next(".accordion_body")
            .toggle();
        $(this)
            .children(".plusminus")
            .addClass("-rotate-90")
            .removeClass("rotate-90");
    }
});
